import { useState, useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import Sidebar from "./Sidebar";
// import EnhancedTable from "./common/EnhancedTable";
import Approval from "./Approval";
import { useParams, useNavigate, generatePath } from "react-router-dom";
import { useEffect } from "react";
import memlogo from "../assets/img/mlogo.png";
// import dashlogo from "../assets/img/dashbarlogo.png";
import clocklogo from "../assets/img/timelogo.png";
import http from "../api/server";
import StatusPill from "./common/StatusPill";
import dayjs from "dayjs";
import PreviewPDF from "./PreviewPdf/PreviewPdf";
// import dashlogo from "../assets/img/dashbarlogo.png";
import Iframe from "react-iframe";
import {
  GET_PROPERTY_COMPLIANCE_SUMMARY,
  GET_PROPERTY_USER_MAPPING,
  UPDATE_PROPERTY_USER_MAPPING_STATUS,
  DOOR_INSPECTION_API,
  GET_PROPERTY_INFO_WITH_MASTER,
  GET_CLINET_ID_API,
  SEND_INSPECTOR_NOTIFICATION_APPROVAL,
  GET_ALL_INSPECTION_MASTER,
  GET_ALL_DOORS_OF_INSPECTION,
} from "../api/apiPath";
// import useGetClientId from "../hooks/useGetClientId";
import { UserRoles, Statuses } from "../components/common/constant";
import { useSelector } from "react-redux";
import Toaster from "./common/Toaster";
import DataGridTable from "./common/DataGridTable";
import ConfirmationPopup from "./common/ConfirmationPopup";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";
import { usePropertyReportPreload } from "./ReportPreview/hooks/usePropertyReportPreload";

import searchIcon from "../assets/img/searchIcon.png";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import actionSearchIcon from "../assets/img/actionSearchIcon.png";
import AutocompleteInput from "./common/AutocompleteInput";

const PropertyViewDetails = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [complianceData, setComplianceData] = useState(null);
  const [filteredComplianceData, setfilteredComplianceData] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [showSubmitLoader, setShowSubmitLoader] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const { clientNameParam, propertyMasterId, inspectionRefnumber } =
    useParams();
  const [showModal, setShowModal] = useState(false);
  const [showPreviewPDF, setShowPreviewPDF] = useState(false);
  //const location = useLocation();
  //const { propertyInfo, userRole } = location.state || {};
  // const [showApprovalButton, setShowApprovalButton] = useState(false);
  const [showSubmitForApprovalButton, setShowSubmitForApprovalButton] =
    useState(false);
  const { userObj } = useSelector((state) => state.user);
  const [showConfimBox, setShowConfimBox] = useState(false);
  const [propertyUserRoleMappingId, setPropertyUserRoleMappingId] =
    useState(null);
  const [inspectorInspectionStatus, setInspectorInspectionStatus] =
    useState(null);
  const pageNumberForFetchRef = useRef(2); // ✅ always current, no stale closure
  const defaultPageSize = 10;
  const isFetchingMoreRows = useRef(false);
  const [fetchingMoreRows, setFetchingMoreRows] = useState(false);

  const hasMoreRows = useRef(true);

  // const clientObj = useGetClientId();
  const [propertyInfo, setPropertyInfo] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [propertyStatus, setPropertyStatus] = useState(null);
  const [noRecord, setNoRecord] = useState(false);
  //eslint-disable-next-line no-unused-vars
  const [isAnonymsProperty, setisAnonymsProperty] = useState(false);
  const [showNewSurveyButton, setShowNewSurveyButton] = useState(false);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [filteredRows, setFilteredRows] = useState([]);
  const [inspectionPropertyData, setInpsectionPropertyData] = useState({});
  //eslint-disable-next-line no-unused-vars
  const [showNotifyButton, setshowNotifyButton] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [isnextInspectionDateNull, setIsNextInspectionDateNull] =
    useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  // const [showSelectAll, setShowSelectAll] = useState(false);
  // const [allSelected, setAllSelected] = useState(true);
  const [toolbar, setToolBar] = useState({
    searchText: "",
    doorRefNo: "Door Reference No.",
    fireRating: "Fire Rating",
    compliance: "Compliance",
    status: "Status",
    pageSize: "Page Size",
  });
  //eslint-disable-next-line no-unused-vars
  const [isRequestForChange, setIsRequestForChange] = useState(false);
  const [allDOorsList, setAllDoorsList] = useState([]);
  const [searchResultsEmpty, setSearchResultsEmtpy] = useState(false);

  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const mainScreenReady = !loading;
  usePropertyReportPreload(
    propertyMasterId,
    inspectionRefnumber,
    mainScreenReady,
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseClient = await http.get(
          GET_CLINET_ID_API + "/" + userObj?.userId,
        );
        setUserRole(responseClient?.data?.roleId);
        await getInspectionMasterInfo(
          responseClient?.data?.clientId,
          responseClient?.data?.roleId,
        );
        await getAllDoors();

        // const response = await http.get(
        //   `${GET_PROPERTY_COMPLIANCE_SUMMARY}?propertyMasterId=${propertyMasterId}` ///InspectionReferenceNumber=${inspectionRefnumber}`
        // );
        // const response = await http.get(
        //   `${GET_PROPERTY_COMPLIANCE_SUMMARY}` +
        //     `?propertyMasterId=${encodeURIComponent(propertyMasterId)}` +
        //     `&InspectionReferenceNumber=${encodeURIComponent(
        //       inspectionRefnumber
        //     )}` + `&userId=${encodeURIComponent(userObj.userId)}`
        // );
        const payload = {
          propertyMasterId: propertyMasterId,
          inspectionReferenceNumber: inspectionRefnumber,
          userId: userObj?.userId,
          pageNumber: 1,
          pageSize: 10,
          searchText: "",
          doorRefNumberFilter: "",
          fireRatingFilter: "",
          complianceFilter: "",
          statusFilter: "",
        };
        // const response = await http.post(
        //   `${GET_PROPERTY_COMPLIANCE_SUMMARY}` +
        //     `?propertyMasterId=${encodeURIComponent(propertyMasterId)}` +
        //     `&inspectionReferenceNumber=${encodeURIComponent(inspectionRefnumber)}` +
        //     `&userId=${encodeURIComponent(userObj?.userId)}`,
        // );

        const response = await http.post(
          GET_PROPERTY_COMPLIANCE_SUMMARY,
          payload,
        );

        setComplianceData(response.data);
        setPropertyStatus(response?.data?.propertyStatus);
        setfilteredComplianceData(response.data);
        setFilteredRows(response.data?.doorComplianceDetails || []);
        const tempApprovalpending =
          response?.data?.doorComplianceDetails.filter(
            (x) => x.status === Statuses.DOORUNDERREVIEW,
          );
        if (tempApprovalpending.length > 0) {
          setshowNotifyButton(false);
        } else {
          const temprequestForChange =
            response?.data?.doorComplianceDetails.filter(
              (x) => x.status === Statuses.REQUESTFORCHANGE,
            );

          if (temprequestForChange.length > 0) {
            setshowNotifyButton(true);
          } else {
            setshowNotifyButton(false);
          }
        }
        const temprequestForChange1 =
          response?.data?.doorComplianceDetails.filter(
            (x) => x.status === Statuses.REQUESTFORCHANGE,
          );

        if (temprequestForChange1.length > 0) {
          setIsRequestForChange(true);
        } else {
          setIsRequestForChange(false);
        }
        const response1 = await http.get(
          GET_PROPERTY_INFO_WITH_MASTER +
            propertyMasterId +
            "?InspectionReferenceNumber=" +
            inspectionRefnumber,
        );
        if (!response1.status) {
          throw new Error(`HTTP error! status: ${response1?.status}`);
        }
        setPropertyInfo(response1?.data?.inspectionPropertyInfo);

        if (
          response1?.data?.inspectionPropertyInfo?.nextInspectionDueDate ===
            null ||
          response1?.data?.inspectionPropertyInfo?.nextInspectionDueDate ===
            "0001-01-01T00:00:00"
        ) {
          setIsNextInspectionDateNull(true);
        } else {
          setIsNextInspectionDateNull(false);
        }

        setisAnonymsProperty(
          response1?.data?.inspectionPropertyInfo?.property?.isAnonymsProperty,
        );

        await getPropertyUserMapping(responseClient?.data?.roleId);
      } catch (error) {
        if (error?.status === 404) {
          setNoRecord(true);
        } else {
          throw new Error(`HTTP error! status: ${error}`);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [showApproveModal]);

  const fetchNextDoorBatch = async () => {
    if (isFetchingMoreRows.current || !hasMoreRows.current) return;
    isFetchingMoreRows.current = true;
    setFetchingMoreRows(true); // ✅
    const pageToFetch = pageNumberForFetchRef.current; // ✅ capture current value
    pageNumberForFetchRef.current += 1; // ✅ increment immediately before await

    try {
      const payload = {
        propertyMasterId: propertyMasterId,
        inspectionReferenceNumber: inspectionRefnumber,
        userId: userObj?.userId,
        pageNumber: pageToFetch,
        pageSize:
          toolbar.pageSize === "Page Size" ? defaultPageSize : toolbar.pageSize,
        searchText: toolbar.searchText || "",
        doorRefNumberFilter:
          toolbar.doorRefNo !== "Door Reference No." ? toolbar.doorRefNo : "",
        fireRatingFilter:
          toolbar.fireRating !== "Fire Rating" ? toolbar.fireRating : "",
        complianceFilter:
          toolbar.compliance !== "Compliance" ? toolbar.compliance : "",
        statusFilter: toolbar.status !== "Status" ? toolbar.status : "",
      };

      const response = await http.post(
        GET_PROPERTY_COMPLIANCE_SUMMARY,
        payload,
      );

      if (response?.status === 200) {
        const newDoors = response.data?.doorComplianceDetails ?? [];

        if (newDoors.length === 0) {
          hasMoreRows.current = false;
          pageNumberForFetchRef.current -= 1; // ✅ roll back if no data
          return;
        }

        // ✅ Merge new doors into existing compliance data
        setComplianceData((prev) => ({
          ...prev,
          doorComplianceDetails: [
            ...(prev?.doorComplianceDetails ?? []),
            ...newDoors,
          ],
        }));

        setfilteredComplianceData((prev) => ({
          ...prev,
          doorComplianceDetails: [
            ...(prev?.doorComplianceDetails ?? []),
            ...newDoors,
          ],
        }));

        setFilteredRows((prev) => [...prev, ...newDoors]);
      }
    } catch (error) {
      console.error("Error fetching next door batch:", error);
      pageNumberForFetchRef.current -= 1; // ✅ roll back if no data
    } finally {
      isFetchingMoreRows.current = false;
      setFetchingMoreRows(false); // ✅
    }
  };

  const fetchFilteredComplianceData = async (toolbarData) => {
    setLoading(true);
    const pageToFetch = 1; // ✅ increment immediately before await
    pageNumberForFetchRef.current = 2;

    try {
      const payload = {
        propertyMasterId: propertyMasterId,
        inspectionReferenceNumber: inspectionRefnumber,
        userId: userObj?.userId,
        pageNumber: pageToFetch,
        pageSize:
          toolbar.pageSize === "Page Size" ? defaultPageSize : toolbar.pageSize,
        searchText: (toolbarData.searchText ?? "").trim(),
        doorRefNumberFilter:
          toolbarData.doorRefNo !== "Door Reference No."
            ? toolbarData.doorRefNo
            : "",
        fireRatingFilter:
          toolbarData.fireRating !== "Fire Rating"
            ? toolbarData.fireRating
            : "",
        complianceFilter:
          toolbarData.compliance !== "Compliance" ? toolbarData.compliance : "",
        statusFilter: toolbarData.status !== "Status" ? toolbarData.status : "",
      };

      const response = await http.post(
        GET_PROPERTY_COMPLIANCE_SUMMARY,
        payload,
      );

      if (response?.status === 200) {
        setSearchResultsEmtpy(false);

        const freshDoors = response.data?.doorComplianceDetails ?? [];

        // ✅ replace all doors into existing compliance data
        setComplianceData((prev) => ({
          ...prev,
          doorComplianceDetails: [...freshDoors],
        }));

        setfilteredComplianceData((prev) => ({
          ...prev,
          doorComplianceDetails: [...freshDoors],
        }));

        setFilteredRows(freshDoors ?? []);
      }
    } catch (error) {
      if (
        error?.status === 404 &&
        error?.data === "No compliance summary found for the given property."
      ) {
        setComplianceData((prev) => ({
          ...prev,
          doorComplianceDetails: [],
        }));

        setfilteredComplianceData((prev) => ({
          ...prev,
          doorComplianceDetails: [],
        }));

        setFilteredRows([]);
        setSearchResultsEmtpy(true);
      }

      console.error("Error fetching next door batch:", error);
    } finally {
      setLoading(false);
    }
  };

  const getAllDoors = async () => {
    try {
      const doorsResponse = await http.get(GET_ALL_DOORS_OF_INSPECTION, {
        params: {
          inspectionRefNumber: inspectionRefnumber,
          propertyMasterId: propertyMasterId,
        },
      });

      if (doorsResponse?.status === 200) {
        setAllDoorsList(
          doorsResponse?.data?.sort((a, b) =>
            (a?.DoorReferenceNumber || "").localeCompare(b?.DoorReferenceNumber || ""),
          ),
        );
      }
    } catch (error) {
      console.error("Error fetching door master info:", error);
    }
  };

  const getInspectionMasterInfo = async (clientid, userrole) => {
    try {
      const inspectionResponse = await http.get(
        GET_ALL_INSPECTION_MASTER + "?ClientId=" + clientid,
      );
      if (inspectionResponse.status === 200) {
        const editData = inspectionResponse?.data?.filter(
          (x) => x.inspectionReferenceNumber == inspectionRefnumber,
        );
        if (editData.length > 0) {
          const tempNewSurveyButton =
            (userrole === UserRoles.INSPECTOR ||
              userrole === UserRoles.ADMIN) &&
            (editData[0].status === Statuses.INPROGRESS ||
              editData[0].status === Statuses.SCHEDULED) &&
            new Date(editData[0].scheduledInspectionDate) <= new Date() &&
            new Date(editData[0].scheduledInspectionDate).getFullYear() >
              new Date().getFullYear() - 1;
          setShowNewSurveyButton(tempNewSurveyButton);
          setInpsectionPropertyData({
            ...inspectionPropertyData,
            status: editData[0].status,
            scheduledInspectionDate: editData[0].scheduledInspectionDate,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching inspection master info:", error);
    }
  };
  const gotoDashBoard = () => {
    //const pathTemplate = "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber";
    const pathTemplate =
      "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyMasterId,
      inspectionRefnumber: inspectionRefnumber,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const getPropertyUserMapping = async (userRoleId) => {
    const propInfoResp = await http.get(
      GET_PROPERTY_USER_MAPPING +
        propertyMasterId +
        "?inspectionRefNumber=" +
        inspectionRefnumber,
    );
    if (!propInfoResp.status) {
      throw new Error(`HTTP error! status: ${propInfoResp?.status}`);
    }
    var status = propInfoResp?.data?.filter(
      (d) => d.userId == userObj.userId,
    )[0]?.status;
    if (status) {
      setInspectorInspectionStatus(status);
    }
    var propertyUserRoleMappingId = propInfoResp?.data?.filter(
      (d) => d.userId == userObj.userId,
    )[0]?.propertyUserRoleMappingId;
    setPropertyUserRoleMappingId(propertyUserRoleMappingId);
    if (
      status == Statuses.INPROGRESS ||
      status == Statuses.NOTSTARTED ||
      userRoleId === UserRoles.ADMIN
    ) {
      setShowSubmitForApprovalButton(true);
    }

    // var totalInspector = propInfoResp?.data.length;
    // var totalInspector =
    //   propInfoResp?.data?.filter((item) => item.roleId === 2).length ?? 0;

    // var totalCompleted = propInfoResp?.data.filter(
    //   (x) => x.status == Statuses.COMPLETED && x.roleId === UserRoles.INSPECTOR
    // ).length;
    // if (totalInspector > 0) {
    //   if (totalInspector == totalCompleted) {
    //     setShowApprovalButton(true);
    //   } else {
    //   setShowApprovalButton(false);
    //   }
    // }
  };
  const onSubmitForApproval = () => {
    setShowConfimBox(true);
  };
  const UpdateStatus = async () => {
    setShowSubmitLoader(true);

    const payload = {
      propertyUserRoleMappingId:
        userRole === UserRoles.ADMIN ? 0 : propertyUserRoleMappingId,
      status: Statuses.COMPLETED,
      propertyMasterId: propertyMasterId,
      userId: userObj?.userId,
      email: userObj?.userEmail,
      inspectionReferenceNumber: inspectionRefnumber,
      BuildingId: complianceData?.buildingId || null,
    };
    try {
      const response = await http.put(
        UPDATE_PROPERTY_USER_MAPPING_STATUS +
          (userRole === UserRoles.ADMIN ? "Admin" : propertyUserRoleMappingId),
        payload,
      );
      console.log("response", response);
      if (response?.status === 200) {
        const message =
          response?.data?.message || "Survey has been submitted for approval";
        response?.data?.isSuccess
          ? setToastData({
              toastShow: true,
              toastType: "success",
              toastString: message,
            })
          : setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: message,
            });
      } else {
        const message =
          response?.data?.message || "Error in saving data, please try again";
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: message,
        });
      }

      if (!response.status) {
        const message =
          response?.data?.message || "Error in saving data, please try again";
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: message,
        });
      }
      setShowConfimBox(false);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error("API Error:", error);
      const message =
        error?.data?.message || "Error in saving data, please try again";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: message,
      });
      // Display error message to user, if needed
    } finally {
      setShowSubmitLoader(false);
    }
  };

  const handleCancel = () => {
    setShowConfimBox(false);
  };

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const handleDownloadClick = async (propertyMasterId) => {
    setShowLoader(true);
    try {
      const response = await http.get(DOOR_INSPECTION_API, {
        params: {
          propertyId: propertyMasterId,
          inspectionReferenceNumber: inspectionRefnumber,
        },
        responseType: "blob",
      });

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      setPdfUrl(fileURL);
      if (isMobile) {
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = `${propertyMasterId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setShowPdfModal(true); // 👉 show modal
      }
    } catch (error) {
      console.error("Download Failed", error);
    } finally {
      setShowLoader(false);
    }
  };

  const criticalIssues = filteredComplianceData?.criticalNonComplianceCount;
  const handleBack = () => {
    const pathTemplate = "/client/:clientNameParam/property-form";
    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };
  // ✅ ADD THIS HELPER FUNCTION (TOP OF FILE)
  const normalizeCompliance = (value) => {
    if (!value) return "";
    if (value.includes("Critical")) return Statuses.CRITICAL;
    if (value.includes("Non-Compliant")) return Statuses.NONCOMPLIANT;
    if (value.includes("Compliant")) return Statuses.COMPLIANT;
    return value;
  };

  //eslint-disable-next-line no-unused-vars
  const handleFilterRows = (rows) => {
    setFilteredRows(rows);

    if (!rows || rows.length === 0) {
      setfilteredComplianceData(complianceData);
      return;
    }

    const compliant = rows.filter(
      (row) => normalizeCompliance(row.compliance) === Statuses.COMPLIANT,
    ).length;

    const nonCompliant = rows.filter(
      (row) => normalizeCompliance(row.compliance) === Statuses.NONCOMPLIANT,
    ).length;

    const critical = rows.filter(
      (row) => normalizeCompliance(row.compliance) === Statuses.CRITICAL,
    ).length;

    setfilteredComplianceData({
      ...complianceData,
      totalDoors: rows.length,
      compliantCount: compliant,
      nonCompliantCount: nonCompliant,
      criticalNonComplianceCount: critical,
      complianceRate: rows.length ? (compliant / rows.length) * 100 : 0,
    });
  };

  const isAnyFilterApplied =
    toolbar.searchText !== "" ||
    toolbar.doorRefNo !== "Door Reference No." ||
    toolbar.fireRating !== "Fire Rating" ||
    toolbar.compliance !== "Compliance" ||
    toolbar.status !== "Status" ||
    toolbar.pageSize !== "Page Size";

  // Debounced search handler
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      // Automatically refresh data when filter changes (with debounce) when all filters are reset manually
      // This catches cases where user deletes filter input without clicking search button
      if(!isAnyFilterApplied){

        fetchFilteredComplianceData(toolbar);
      }
    }, 500); // 500ms debounce delay

    return () => clearTimeout(debounceTimer);
  }, [toolbar.searchText, toolbar.doorRefNo, toolbar.fireRating, toolbar.compliance, toolbar.status, toolbar.pageSize]);

  const filterDoorRefOnly = () => {
    const filtered = complianceData.doorComplianceDetails.filter((row) => {
      const matchesDoor =
        toolbar.doorRefNo === "Door Reference No." ||
        row.doorRefNumber === toolbar.doorRefNo;
      return matchesDoor;
    });
    filtered.length > 0
      ? setFilteredRows(filtered)
      : fetchFilteredComplianceData(toolbar);
  };

  // useEffect(() => {
  //   if (!complianceData?.doorComplianceDetails) return;

  // //   // ✅ Reset infinite load state on filter change
  // // hasMoreRows.current = true;
  // // pageNumberForFetchRef.current = 2;

  //   const filtered = complianceData.doorComplianceDetails.filter((row) => {
  //     const matchesSearch =
  //       !toolbar.searchText ||
  //       row.doorRefNumber
  //         ?.toLowerCase()
  //         .includes(toolbar.searchText.toLowerCase());

  //     const matchesDoor =
  //       toolbar.doorRefNo === "Door Reference No." ||
  //       row.doorRefNumber === toolbar.doorRefNo;

  //     const matchesFire =
  //       toolbar.fireRating === "Fire Rating" ||
  //       row.fireRating === toolbar.fireRating;

  //     // const matchesCompliance =
  //     //   toolbar.compliance === "Compliance" ||
  //     //   normalizeCompliance(row.compliance) === toolbar.compliance;

  //     const matchesCompliance =
  //       toolbar.compliance === "Compliance" ||
  //       normalizeCompliance(row.compliance) ===
  //         normalizeCompliance(toolbar.compliance);

  //     const matchesStatus =
  //       toolbar.status === "Status" || row.status === toolbar.status;

  //     return (
  //       matchesSearch &&
  //       matchesDoor &&
  //       matchesFire &&
  //       matchesCompliance &&
  //       matchesStatus
  //     );
  //   });

  //   setFilteredRows(filtered);

  //   // ✅ ONLY RECALCULATE WHEN FILTER IS APPLIED
  //   if (!isAnyFilterApplied) {
  //     setfilteredComplianceData(complianceData);
  //     return;
  //   }

  //   handleFilterRows(filtered);
  // }, [toolbar, complianceData]);

  const closePopup = () => {
    setShowConfirmationPopup(false);
  };

  const notifyInspectorApi = async () => {
    setButtonLoading(true);
    try {
      const response = await http.post(SEND_INSPECTOR_NOTIFICATION_APPROVAL);
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      response.status === 200
        ? setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Notification has been sent successfully",
          })
        : setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in sending notification, please try again",
          });
      setShowConfirmationPopup(false);
    } catch (error) {
      setShowConfirmationPopup(false);
      throw new Error(`HTTP error! status: ${error}`);
    } finally {
      setButtonLoading(false);
    }
  };
  const handleApprovalModalOpen = () => {
    console.log("pp", propertyInfo, propertyStatus);
    setShowApproveModal(true);
  };
  // console.log("pp", propertyInfo, propertyStatus);

  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />
      <ConfirmationPopup
        show={showConfirmationPopup}
        headingText="Notify Inspectors"
        infoText="Please confirm if you want to send an email notification to all the Inspectors"
        cancelText="Cancel"
        submitText={buttonLoading ? "Please Wait" : "Send"}
        onCancel={() => {
          closePopup();
        }}
        onSubmit={() => notifyInspectorApi()}
      />
      <div className="dashboard_body_main">
        {/* {loading ? (
          <div className="spinloader"></div>
        ) : ( */}
        {hideSidebar ? (
          <Sidebar setHideSidebar={setHideSidebar} hideSidebar={hideSidebar} />
        ) : (
          <SidebarIcons
            setHideSidebar={setHideSidebar}
            hideSidebar={hideSidebar}
          />
        )}
        <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
          {(userRole === UserRoles.APPROVER || userRole === UserRoles.ADMIN) &&
            propertyInfo?.status == Statuses.COMPLETED &&
            isnextInspectionDateNull && (
              <div className="mb-3">
                <div className="d-flex align-items-center gap-2 information-icon w-auto float-end">
                  <i
                    className="bi bi-info-circle"
                    style={{ fontSize: "1.2rem", marginTop: "-7px" }}
                  ></i>
                  <small>
                    The next inspection Due date for this property has not been
                    set.
                  </small>
                  <span
                    className="badge bg-warning text-dark rounded-button"
                    onClick={() => setShowDateModal(true)}
                  >
                    Set Inspection Date
                  </span>
                </div>
              </div>
            )}
          <div className="dashboard_header mb-3">
            <div className="d-flex pv-actions justify-content-between">
              <h2 className="mb-0">Compliance Summary</h2>
              {criticalIssues >= 1 && (
                <div className="d-flex align-items-center gap-2 information-icon">
                  <i
                    className="bi bi-info-circle"
                    style={{ fontSize: "1.2rem" }}
                  ></i>
                  <small className="text-wrap">
                    Some doors require attention to maintain compliance
                  </small>
                  <span className="badge bg-warning text-dark rounded-circle">
                    {criticalIssues}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div
            className="p-3 mb-4 orange-box d-flex gap-3 "
            // style={{ height: "9.5rem" }}
          >
            <div className="w-100">
              {noRecord ? (
                <div className="text-center py-4">No record found</div>
              ) : (
                <div className="text-center orange-box-inner d-flex justify-content-evenly align-items-center">
                  <div className="d-flex w-100 flex-row justify-content-between">
                    <div className="w-100">
                      <p
                        className="mb-0 orange-box-number"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-1.3px",
                        }}
                      >
                        {isNaN(filteredComplianceData?.complianceRate)
                          ? filteredComplianceData?.complianceRate
                          : Math.round(
                              Number(filteredComplianceData?.complianceRate),
                            )}
                        %
                      </p>
                      <p
                        className="mb-0 orange-box-text"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        {" "}
                        Overall Compliance Rate
                      </p>
                    </div>

                    <div className="w-100">
                      <p
                        className="mb-0 orange-box-number"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-1.3px",
                        }}
                      >
                        {filteredComplianceData?.totalDoors}
                      </p>
                      <p
                        className="mb-0 orange-box-text"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        Total Doors
                      </p>
                    </div>
                  </div>
                  {/* <div className="col-6 col-sm-2 col-lg-2 mb-1">
                    <img
                      src={dashlogo} // replace with your image path
                      alt="Inspector"
                      height="100"
                    />
                  </div> */}
                  <div className="black-line"></div>

                  <div className="d-flex flex-row w-100 justify-content-between">
                    <div className="w-100">
                      <p
                        className="mb-0 orange-box-number"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-1.3px",
                        }}
                      >
                        {filteredComplianceData?.compliantCount}
                      </p>
                      <p
                        className="mb-0 orange-box-text"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        Compliant
                      </p>
                    </div>
                    <div className="w-100">
                      <p
                        className="mb-0 orange-box-number"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-1.3px",
                        }}
                      >
                        {filteredComplianceData?.nonCompliantCount}
                      </p>
                      <p
                        className="mb-0 orange-box-text"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        Non-Compliant
                      </p>
                    </div>
                    <div className="w-100">
                      <p
                        className="mb-0 orange-box-number"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-1.3px",
                        }}
                      >
                        {filteredComplianceData?.criticalNonComplianceCount}
                      </p>
                      <p
                        className="mb-0 orange-box-text"
                        style={{
                          fontWeight: "500",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        Critical Issues
                      </p>
                    </div>
                  </div>
                  {/* <div className="col-4 col-sm-2">
                      <h3>1</h3>
                      <p className="fw-semibold">Require Attention</p>
                    </div> */}
                </div>
              )}
            </div>
          </div>

          <div className="resident-card mb-3">
            {noRecord ? (
              <div className="text-center py-4">No record found</div>
            ) : (
              <div className=" flex-sm-row align-items-center ">
                <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h5 className="justifyStart fw-bold mb-0">
                      {(complianceData?.buildingName !== null
                        ? complianceData?.buildingName
                        : complianceData?.propertyName) || "Property Name"}
                    </h5>
                    <div className="d-flex flex-row gap-1">
                      {complianceData?.propertyStatus !== Statuses.CANCELLED &&
                        complianceData?.propertyStatus !== Statuses.COMPLETED &&
                        complianceData?.isOverDue && (
                          <p className="justifyCenter mb-0 mt-1">
                            <StatusPill status="Overdue" />
                          </p>
                        )}

                      <p className="justifyCenter mb-0 mt-1">
                        <StatusPill
                          status={
                            complianceData?.propertyStatus === Statuses.INREVIEW
                              ? "In Progress"
                              : complianceData?.propertyStatus || ""
                          }
                        />
                      </p>
                    </div>
                  </div>

                  <p className="justifyStart text mb-0 mt-1">
                    {/* <b>Location</b>:{" "} */}
                    {(complianceData?.buildingName !== null
                      ? complianceData?.propertyName +
                        `, ` +
                        complianceData?.propertyLocation
                      : complianceData?.propertyLocation) || ""}
                  </p>

                  <div className="d-flex justify-content-between align-items-center w-100 mt-4 mb-4 text-black fw-semibold">
                    {/* Inspector */}
                    <p className="d-flex align-items-center mb-0 gap-2">
                      <img
                        src={memlogo} // replace with your image path
                        alt="Inspector"
                        width="16"
                        height="16"
                      />
                      <span className="info-label">Inspector:</span>
                      <span className="info-value">
                        {complianceData?.inspectors || ""}
                      </span>
                    </p>

                    {/* Submitted Date */}
                    {(propertyInfo?.status == Statuses.COMPLETED ||
                      propertyInfo?.status == Statuses.SUBMITTEDFORAPPROVAL ||
                      propertyInfo?.status == Statuses.REJECTED) && (
                      <p className="d-flex align-items-center mb-0 gap-2">
                        <img
                          src={clocklogo} // replace with your image path
                          alt="Date"
                          width="16"
                          height="16"
                        />
                        <span className="info-label">Submitted Date:</span>
                        <span className="info-value">
                          {/* {complianceData?.submittedDate
                          ? new Date(
                              complianceData.submittedDate,
                            ).toLocaleDateString("en-GB", {
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            })
                          : ""} */}
                          {complianceData?.submittedDate
                            ? dayjs(complianceData.submittedDate)
                                .format("DD-MMM-YYYY")
                                .toUpperCase()
                            : ""}
                        </span>
                      </p>
                    )}

                    {/* Another Date */}
                    {propertyInfo?.status == Statuses.COMPLETED && (
                      <p className="d-flex align-items-center mb-0 gap-2">
                        <img
                          src={clocklogo}
                          alt="Date"
                          width="16"
                          height="16"
                        />
                        <span className="info-label">Approved Date:</span>
                        <span className="info-value">
                          {/* {complianceData?.approvalDate
                            ? new Date(
                                complianceData.approvalDate,
                              ).toLocaleDateString("en-GB", {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              })
                            : ""} */}
                          {complianceData?.approvalDate
                            ? dayjs(complianceData.approvalDate)
                                .format("DD-MMM-YYYY")
                                .toUpperCase()
                            : ""}
                        </span>
                      </p>
                    )}
                  </div>

                  {/* <p className="justifyStart mb-0">
                            <b>Inspectors</b>:{" "}
                            {complianceData?.inspectors || ""}
                          </p> */}
                  {/* <p className="justifyStart mb-0">
                            <b>Status</b>:{" "}
                            {complianceData?.propertyStatus ===
                            Statuses.INREVIEW
                              ? "In Progress"
                              : complianceData?.propertyStatus || ""}
                          </p> */}
                  {/* <p className="justifyStart mb-0">
                            <b>Submitted Date</b>:{" "}
                            {complianceData?.submittedDate
                              ? new Date(
                                  complianceData.submittedDate
                                ).toLocaleDateString("en-GB", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                })
                              : "" || ""}
                          </p> */}
                </div>
                <div
                // className="col-12 col-sm-8 col-lg-8 d-flex justify-content-end"
                // style={{
                //   // flexDirection: "column",
                //   // alignItems: "flex-end",
                //   // justifyContent: "flex-end",
                //   height: "-webkit-fill-available",
                // }}
                >
                  <div className="pv-actions w-100 mt-2 d-flex align-items-center justify-content-end gap-2">
                    {showNewSurveyButton && ( //removed !isAnonymousProperty
                      <div className="pv-item w-100">
                        <button
                          className="btn-tertiary shadow w-100"
                          onClick={() => gotoDashBoard()}
                        >
                          New Door Survey
                        </button>
                      </div>
                    )}
                    {/* {(userRole === UserRoles.APPROVER ||
                      userRole === UserRoles.ADMIN) &&
                      propertyInfo?.status == Statuses.SUBMITTEDFORAPPROVAL &&
                      showNotifyButton && (
                        <div className="pv-item w-100">
                          <button
                            className="btn-tertiary shadow w-100"
                            type="button"
                            onClick={() => {
                              setShowConfirmationPopup(true);
                            }}
                          >
                            {" "}
                            Notify Inspectors{" "}
                          </button>
                        </div>
                      )} */}

                    {(userRole === UserRoles.APPROVER ||
                      userRole === UserRoles.ADMIN) &&
                      propertyInfo?.status ===
                        Statuses.SUBMITTEDFORAPPROVAL && (
                        <div className="pv-item w-100">
                          <button
                            className="btn-primary shadow w-100"
                            type="button"
                            onClick={handleApprovalModalOpen}
                          >
                            Approve Survey
                          </button>
                        </div>
                      )}
                    {(userRole === UserRoles.APPROVER ||
                      userRole === UserRoles.ADMIN) &&
                      propertyInfo?.status ===
                        Statuses.SUBMITTEDFORAPPROVAL && (
                        <div className="pv-item w-100">
                          <button
                            className="btn-secondary shadow w-100"
                            type="button"
                            onClick={() => setShowModal(true)}
                          >
                            Reject Survey
                          </button>
                        </div>
                      )}

                    {(userRole === UserRoles.INSPECTOR ||
                      userRole === UserRoles.ADMIN) &&
                      // propertyInfo?.status !== Statuses.COMPLETED &&
                      // propertyInfo?.status !== Statuses.SUBMITTEDFORAPPROVAL &&
                      propertyStatus !== Statuses.SCHEDULED &&
                      propertyStatus !== Statuses.SUBMITTEDFORAPPROVAL &&
                      propertyStatus !== Statuses.COMPLETED &&
                      propertyStatus !== Statuses.NEW && //request for change not considered
                      showSubmitForApprovalButton && (
                        <div className="pv-item w-100">
                          <button
                            type="submit"
                            className="btn-secondary shadow w-100"
                            onClick={onSubmitForApproval}
                          >
                            {propertyInfo?.status === Statuses.REJECTED
                              ? "Re-Submit for Approval"
                              : "Submit for approval"}
                          </button>
                        </div>
                      )}

                    <div className="pv-item w-100">
                      {showLoader ? (
                        <div className="loader"></div>
                      ) : (
                        ((propertyInfo?.status !== Statuses.NEW &&
                          propertyInfo?.status !== Statuses.SCHEDULED &&
                          propertyInfo?.status !== null &&
                          propertyInfo?.status !== undefined) ||
                          propertyStatus === Statuses.INPROGRESS ||
                          propertyStatus === Statuses.SUBMITTEDFORAPPROVAL ||
                          propertyStatus === Statuses.COMPLETED ||
                          propertyStatus === Statuses.REJECTED) && (
                          <button
                            type="report"
                            className="btn-primary shadow w-100"
                            title="Generate Report"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleDownloadClick(propertyMasterId);
                            }}
                          >
                            Preview / Download
                          </button>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="dashboard_header d-flex flex-row align-items-center justify-content-between mb-3">
            <div className="d-flex flex-row align-items-center">
              <h2 className="mb-0">Door Surveys</h2>
              {/* {userRole === UserRoles.APPROVER &&
                propertyInfo?.status == Statuses.SUBMITTEDFORAPPROVAL && (
                  <i
                    className="bi bi-info-circle"
                    style={{
                      fontSize: "0.9rem",
                      marginTop: "-7px",
                      marginLeft: "5px",
                    }}
                    title="To Approve the complete survey, please make sure all doors are selected and click on 'Approve All Doors' button. 
                      To approve the surveys individually, please click on the view icon below"
                  ></i>
                )} */}
            </div>
            {/* {console.log("all selected button", allSelected)} */}
            {/* {showSelectAll && (
              <div className="col-auto ms-auto">
                <button
                  className="btn-primary"
                  onClick={() => handleApprovalModalOpen()}
                  disabled={!allSelected}
                >
                  Approve All Doors
                </button>
              </div>
            )} */}

            {/* {(userRole === UserRoles.APPROVER ||
              userRole === UserRoles.ADMIN) &&
              propertyInfo?.status === Statuses.SUBMITTEDFORAPPROVAL && (
                <div className="col-auto ms-auto">
                  <button
                    className="btn-primary"
                    onClick={handleApprovalModalOpen}
                  >
                    Approve Survey
                  </button>
                </div>
              )} */}
          </div>

          <div className="row py-3 align-items-center g-2 mb-3">
            {/* Search Bar */}
            <div className="custom_toolbar_search col-6 col-md-3 ">
              <img src={searchIcon} />
              <input
                type="text"
                className="form-control custom_toolbar_control ps-5"
                id="floatingInput"
                placeholder="Search..."
                value={toolbar.searchText}
                onChange={(e) =>
                  setToolBar({ ...toolbar, searchText: e.target.value })
                }
              />
            </div>

            {/* Dropdowns */}
            <div className="col-6 col-md-2">
              {/* <select
                className="form-select custom_toolbar_control"
                value={toolbar.doorRefNo}
                onChange={(e) =>
                  setToolBar({ ...toolbar, doorRefNo: e.target.value })
                }
              >
                <option value="Door Reference No.">Door Reference No.</option>
                {[
                  ...new Set(
                    allDOorsList?.map(
                      (door) => door.DoorReferenceNumber,
                    ),
                  ),
                ].map((cityItem, index) => (
                  <option key={index} value={cityItem}>
                    {cityItem}
                  </option>
                ))}
              </select> */}
              <AutocompleteInput
                // key={}
                masterList={allDOorsList}
                getOptionLabel={(site) => site?.DoorReferenceNumber || ""}
                getOptionValue={(site) => site?.DoorReferenceNumber || ""}
                // value={toolbar.propertyName}
                value={
                  toolbar.doorRefNo === "Door Reference No."
                    ? ""
                    : toolbar.doorRefNo
                }
                onValueChange={(value) =>
                  setToolBar({
                    ...toolbar,
                    doorRefNo: value || "Door Reference No.",
                  })
                }
                placeholder="Door Reference No."
                inputClassName="form-control custom_toolbar_control mt-1"
                notFoundText="Door Reference No. not found"
              />
            </div>
            <div className="col-6 col-md-1" style={{ width: "auto" }}>
              <select
                className="form-select custom_toolbar_control"
                value={toolbar.fireRating}
                onChange={(e) =>
                  setToolBar({ ...toolbar, fireRating: e.target.value })
                }
              >
                <option value="Fire Rating">Fire Rating</option>
                {[
                  ...new Set(
                    complianceData?.doorComplianceDetails?.map(
                      (door) => door.fireRating,
                    ),
                  ),
                ].map((cityItem, index) => (
                  <option key={index} value={cityItem}>
                    {cityItem}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6 col-md-2">
              <select
                className="form-select custom_toolbar_control"
                value={toolbar.compliance}
                onChange={(e) =>
                  setToolBar({ ...toolbar, compliance: e.target.value })
                }
              >
                <option value="Compliance">Compliance</option>
                {/* {[
                  ...new Set(
                    complianceData?.doorComplianceDetails?.map(
                      (door) => door.compliance,
                    ),
                  ),
                ].map((cityItem, index) => (
                  <option key={index} value={cityItem}>
                    {cityItem}
                  </option>
                ))} */}
                {criticalIssues && criticalIssues > 0 && (
                  <option>Non-Compliant: Critical</option>
                )}
                {filteredComplianceData?.nonCompliantCount &&
                  filteredComplianceData?.nonCompliantCount > 0 && (
                    <option>Non-Compliant</option>
                  )}
                {filteredComplianceData?.compliantCount &&
                  filteredComplianceData?.compliantCount > 0 && (
                    <option>Compliant</option>
                  )}
              </select>
            </div>
            <div className="col-6 col-md-1">
              <select
                className="form-select custom_toolbar_control"
                value={toolbar.status}
                onChange={(e) =>
                  setToolBar({ ...toolbar, status: e.target.value })
                }
              >
                <option value="Status">Status</option>
                {[
                  ...new Set(
                    complianceData?.doorComplianceDetails?.map(
                      (door) => door.status,
                    ),
                  ),
                ].map((cityItem, index) => (
                  <option key={index} value={cityItem}>
                    {cityItem}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6 col-md-1" style={{ width: "auto" }}>
              <select
                className="form-select custom_toolbar_control"
                value={toolbar.pageSize}
                onChange={(e) =>
                  setToolBar({ ...toolbar, pageSize: e.target.value })
                }
              >
                <option value="Page Size">Page Size</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={40}>40</option>
                <option value={50}>50</option>
              </select>
            </div>
            <button
              type="button"
              style={{ width: "auto" }}
              className="btn btn-dark"
              disabled={!isAnyFilterApplied}
              onClick={() => {
                if (
                  toolbar.searchText === "" &&
                  toolbar.doorRefNo !== "Door Reference No." &&
                  toolbar.fireRating === "Fire Rating" &&
                  toolbar.compliance === "Compliance" &&
                  toolbar.status === "Status" &&
                  toolbar.pageSize === 30
                ) {
                  filterDoorRefOnly();
                } else {
                  fetchFilteredComplianceData(toolbar);
                }
              }}
            >
              <img src={actionSearchIcon}></img>
            </button>
            {isAnyFilterApplied && (
              <div style={{ width: "auto", paddingLeft: "0px" }}>
                <IconButton
                  tabIndex={0}
                  title="Clear Filters"
                  onClick={() => {
                    setToolBar({
                      searchText: "",
                      doorRefNo: "Door Reference No.",
                      fireRating: "Fire Rating",
                      compliance: "Compliance",
                      status: "Status",
                      pageSize: "Page Size",
                    });
                    fetchFilteredComplianceData({
                      searchText: "",
                      doorRefNo: "Door Reference No.",
                      fireRating: "Fire Rating",
                      compliance: "Compliance",
                      status: "Status",
                      pageSize: "Page Size",
                    });
                  }}
                >
                  <ClearIcon sx={{ color: "#717186" }} fontSize="small" />
                </IconButton>
              </div>
            )}
          </div>

          <div className="">
            {/* {complianceData?.doorComplianceDetails?.length > 0 && (
                      <EnhancedTable
                        tableData={complianceData.doorComplianceDetails}
                      />
                    )} */}
            {noRecord || searchResultsEmpty ? (
              <div className="text-center py-4">
                {noRecord
                  ? "No record found"
                  : searchResultsEmpty
                    ? "No search results matched"
                    : "No data"}
              </div>
            ) : (
              complianceData?.doorComplianceDetails?.length > 0 && (
                <DataGridTable
                  tableData={filteredRows?.sort(
                    (a, b) =>
                      new Date(b.doorInspectionDate) -
                      new Date(a.doorInspectionDate),
                  )}
                  userRole={userRole}
                  propertyInfo={propertyInfo}
                  inspectorInspectionStatus={inspectorInspectionStatus}
                  onFilteredRowsChange={() => {
                    // handleFilterRows(rows);
                  }}
                  onApproveAllButton={() => handleApprovalModalOpen()}
                  pageSize={
                    toolbar.pageSize === "Page Size" ? 10 : toolbar?.pageSize
                  }
                  propertyStatus={propertyStatus}
                  // showSelectAll={showSelectAll}
                  // setShowSelectAll={setShowSelectAll}
                  // allSelected={allSelected}
                  // setAllSelected={setAllSelected}
                  showSelectAll={false} // hide checkbox UI
                  setShowSelectAll={() => {}} // no-op
                  allSelected={true} // always enabled
                  setAllSelected={() => {}}
                  onLastPageReached={fetchNextDoorBatch} // ✅ new prop
                  fetchingMoreRows={fetchingMoreRows}
                  totalDoors={complianceData?.totalDoors}
                  totalLoadedRows={filteredRows?.length} // ✅ so grid knows total
                />
              )
            )}
          </div>
          <div className="button-container">
            <button
              type="back"
              className="btn-secondary col-sm-5 col-md-2"
              onClick={() => {
                handleBack();
              }}
            >
              Back
            </button>
            <button
              type="back"
              className="btn-secondary col-sm-5 col-md-2"
              onClick={() => {
                setShowPreviewPDF(true);
              }}
            >
              Preview Report
            </button>
          </div>
        </div>
        {/* // )} */}
        <Footer />
        <div className="bottom-bar-spacing"></div>
        <BottomBarIcons />
      </div>
      <LoadingComponent loading={loading} />
      {/* for rejecting inspection */}
      {showModal && (
        <Approval
          data={propertyInfo}
          isApprove={false}
          isDueDate={false}
          onClose={() => {
            setShowModal(false);
          }}
          inspectionRefnumber={inspectionRefnumber}
        />
      )}
      {/* for setting next  inspection due date */}
      {showDateModal && (
        <Approval
          data={propertyInfo}
          isApprove={false}
          isDueDate={true}
          onClose={() => {
            setShowDateModal(false);
          }}
          inspectionRefnumber={inspectionRefnumber}
        />
      )}

      {/* for approving inspection */}
      {showApproveModal && (
        <Approval
          data={propertyInfo}
          isApprove={true}
          isDueDate={false}
          onClose={() => {
            setShowApproveModal(false);
          }}
          inspectionRefnumber={inspectionRefnumber}
        />
      )}
      {showConfimBox && (
        <div className="modal-overlay">
          <div
            className="approval-modal-content"
            style={{ height: "fit-content" }}
          >
            <span className="close" onClick={handleCancel}>
              &times;
            </span>
            <h6 className="modal-header">Confirmation</h6> {/* Modal Header */}
            <div className="modal-body" style={{ marginTop: "-10px" }}>
              <span>
                Once you submit for approval, you will no longer be able to
                modify or complete any pending door inspections. Please make
                sure all door surveys are fully completed before proceeding.
              </span>
              <div className="row">
                <div>
                  <div
                    className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap "
                    style={{ marginTop: "5px" }}
                  >
                    {showSubmitLoader ? (
                      <div
                        className="loader mt-2"
                        style={{ marginRight: "20px" }}
                      ></div>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn btn-tertiary"
                          onClick={() => {
                            handleCancel();
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            UpdateStatus();
                          }}
                        >
                          Submit
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showPdfModal && pdfUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              maxHeight: "80vh",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 className="modal-title mb-0">PDF Preview</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowPdfModal(false);
                  setPdfUrl(null);
                }}
              ></button>
            </div>
            <div style={{ height: "90vh", padding: 0 }}>
              <Iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{
                  border: "none",
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
              ></Iframe>
            </div>
          </div>
        </div>
      )}
      {showPreviewPDF && (
        <PreviewPDF
          show={showPreviewPDF}
          propertyMasterId={propertyMasterId}
          inspectionReferenceNumber={inspectionRefnumber}
          cancelText="Close"
          submitText="Download"
          onCancel={() => setShowPreviewPDF(false)}
          onSubmit={() => {
            // Handle submit logic here
          }}
          clientnameParam={clientNameParam}
        />
      )}
    </>
  );
};
export default PropertyViewDetails;
